import { useCallback, useEffect, useState } from 'react'

import { debounce } from 'lodash';
import { Input } from 'twyne-new.ui';

export default function TagsFilter({ onChange, name, value }) {
  const [tags, setTags] = useState('')

  useEffect(() => {
    if (!value) {
      setTags('')
    }
  }, [value])

  const handleChange = useCallback(event => {
    const { value } = event.target
    setTags(value)
    handleOnChange(onChange, value)
  }, [onChange])

  return <Input id={name} value={tags} onChange={handleChange} />
}

const handleOnChange = debounce((onChange, value) => {
  onChange(value)
}, 700)
